<div class="terminal-device-selector">
  <div class="selector-header d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0">
      <mat-icon>credit_card</mat-icon>
      Select Payment Terminal
    </h5>
    <button
      mat-icon-button
      (click)="refreshTerminals()"
      [disabled]="discovering"
      matTooltip="Refresh devices">
      <mat-icon [class.spinning]="discovering">refresh</mat-icon>
    </button>
  </div>

  <div class="loading-container" *ngIf="loading && !terminals.length">
    <mat-spinner diameter="40"></mat-spinner>
    <p class="mt-2 text-muted">Discovering terminals...</p>
  </div>

  <div class="terminals-list" *ngIf="!loading || terminals.length">
    <div
      *ngFor="let terminal of terminals"
      class="terminal-list-item"
      [ngClass]="{
        'selected': selectedTerminal?.terminal_id === terminal.terminal_id,
        'unavailable': !terminal.is_available,
        'needs-registration': terminal.needs_registration
      }"
      (click)="selectTerminal(terminal)">
      
      <div class="d-flex justify-content-between align-items-start">
        <div class="terminal-info flex-grow-1">
          <div class="d-flex align-items-center mb-1">
            <mat-icon class="terminal-icon mr-2">{{ getTerminalIcon(terminal.terminal_model) }}</mat-icon>
            <h6 class="terminal-name mb-0">{{ terminal.terminal_name || 'Unnamed Terminal' }}</h6>
            <mat-icon class="selection-icon ml-auto" *ngIf="selectedTerminal?.terminal_id === terminal.terminal_id">
              check_circle
            </mat-icon>
          </div>
          
          <div class="terminal-details text-muted small">
            <span>{{ terminal.terminal_model === 'imove5000' ? 'iMove 5000' : terminal.terminal_model === 'desk5000' ? 'Desk 5000' : terminal.terminal_model }}</span>
            <span class="mx-1">•</span>
            <mat-icon class="connection-icon">{{ getConnectionIcon(terminal.connection_type) }}</mat-icon>
            <span>{{ (terminal.connection_type || 'lan').toUpperCase() }}</span>
            <span class="mx-1" *ngIf="terminalHealth.get(terminal.terminal_id!)">•</span>
            <span *ngIf="terminalHealth.get(terminal.terminal_id!)">
              <mat-icon class="status-icon" [style.color]="terminalHealth.get(terminal.terminal_id!)?.online ? '#4caf50' : '#f44336'">
                {{ terminalHealth.get(terminal.terminal_id!)?.online ? 'check_circle' : 'error' }}
              </mat-icon>
              {{ terminalHealth.get(terminal.terminal_id!)?.online ? 'Online' : 'Offline' }}
            </span>
          </div>
          
          <div class="terminal-meta text-muted small mt-1" *ngIf="terminal.machine_name || terminal.machine_user">
            <span>Machine: {{ terminal.machine_name || '—' }} | User: {{ terminal.machine_user || '—' }}</span>
          </div>
          <div class="terminal-meta text-muted small mt-1">
            <span *ngIf="terminal.terminal_serial">Serial: {{ terminal.terminal_serial }}</span>
            <span *ngIf="terminal.terminal_serial && (terminal.firmware_version || terminalHealth.get(terminal.terminal_id!)?.firmware_version)" class="mx-1">•</span>
            <span *ngIf="terminal.firmware_version || terminalHealth.get(terminal.terminal_id!)?.firmware_version">
              Firmware: {{ terminal.firmware_version || terminalHealth.get(terminal.terminal_id!)?.firmware_version }}
            </span>
          </div>
          
          <div class="terminal-meta text-muted small mt-1" *ngIf="terminal.terminal_model === 'imove5000' && (terminal.battery_level !== undefined || terminalHealth.get(terminal.terminal_id!)?.battery_level !== undefined)">
            <mat-icon class="small-icon">{{ getBatteryIcon(terminal.battery_level ?? terminalHealth.get(terminal.terminal_id!)?.battery_level) }}</mat-icon>
            Battery: {{ terminal.battery_level ?? terminalHealth.get(terminal.terminal_id!)?.battery_level }}%
          </div>
          
          <div class="availability-badge mt-2" *ngIf="!terminal.is_available">
            <mat-icon>block</mat-icon>
            <span>Unavailable</span>
          </div>
          
          <div class="registration-badge mt-2" *ngIf="terminal.needs_registration">
            <mat-icon>info</mat-icon>
            <span>Needs Registration</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="no-terminals" *ngIf="!loading && !terminals.length">
    <mat-icon class="large-icon">devices_other</mat-icon>
    <p>No terminals found</p>
    <button mat-raised-button color="primary" (click)="refreshTerminals()">
      <mat-icon>refresh</mat-icon>
      Scan for Devices
    </button>
  </div>

  <div class="selection-required" *ngIf="required && !selectedTerminal && terminals.length">
    <mat-icon>warning</mat-icon>
    <span>Please select a terminal to continue</span>
  </div>
</div>


